import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ControlledTextFieldSeparatedLabel from "../../../../components/controlled/ControlledTextFieldSeparatedLabel/index.jsx";
import { useUpdateTelerouteIntegrationMutation } from "../../integrationsApiSlice.js";
import { getFormSchema } from "./formSchema.js";

const TelerouteForm = ({
	status,
	telerouteUsername,
	teleroutePassword,
	enableEdit,
}) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [updateTelerouteIntegration, { isLoading }] =
		useUpdateTelerouteIntegrationMutation();

	const formSchema = getFormSchema(t);
	const {
		handleSubmit,
		control,
		formState: { errors },
		setValue,
		setError,
	} = useForm({
		defaultValues: {
			telerouteUsername,
			teleroutePassword,
		},
		resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	useEffect(() => {
		if (telerouteUsername) {
			setTimeout(() => {
				setValue("telerouteUsername", telerouteUsername);
			}, 200);
		}
		if (teleroutePassword) {
			setTimeout(() => {
				setValue("teleroutePassword", teleroutePassword);
			}, 200);
		}
	}, [telerouteUsername, teleroutePassword, setValue]);

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				if (err.message) {
					enqueueSnackbar(err.message, {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
		}
	}, [errors, enqueueSnackbar]);

	const onSubmit = async ({ telerouteUsername, teleroutePassword }) => {
		await updateTelerouteIntegration({
			telerouteUsername,
			teleroutePassword,
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("updated_tele_integration"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Box
			component="form"
			autoComplete="off"
			noValidate
			onSubmit={handleSubmit(onSubmit)}
			sx={{ p: 0 }}
		>
			<input type="text" style={{ display: "none" }} aria-hidden="true" />
			<input type="password" style={{ display: "none" }} aria-hidden="true" />
			<Grid container spacing={5}>
				<Grid size={6}>
					<Grid container spacing={2}>
						{/* <Grid item xs={12}>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
								}}
							>
								<Typography sx={{ fontWeight: 600 }}>Status: </Typography>
								{status ? (
									<Chip label="zintegrowano" color="success" />
								) : (
									<Chip label="brak integracji" color="secondary" />
								)}
							</Box>
						</Grid> */}
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="telerouteUsername"
								type="text"
								label="Teleroute Username"
								error={!!errors?.telerouteUsername}
								labelXs={6}
								fieldXs={6}
								autoComplete="off telerouteUsername new-password"
								inputProps={{
									autoComplete: "off telerouteUsername new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="teleroutePassword"
								type="password"
								label="Teleroute Password"
								error={!!errors?.teleroutePassword}
								labelXs={6}
								fieldXs={6}
								autoComplete="off teleroutePassword new-password"
								inputProps={{
									autoComplete: "off teleroutePassword new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button loading={isLoading} type="submit" variant="contained">
									{t("save")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={6}>
					<Box
						sx={{
							border: "2px solid #ffc000",
							background: "#ffffd9",
							padding: "14px",
							maxWidth: "500px",
						}}
					>
						<Typography>
							{t("tele_integration_info_1")}
							<br />
							{t("tele_integration_info_2")}
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default TelerouteForm;
